module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('i', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_c('span', [_c('i', [_vm._v("The Cathedral")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_c('span', [_c('i', [_vm._v("Tenth Street")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("The Hunter Portrait")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("Bishop Bodeway’s Past")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("The Kommandant")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("A Concert in Munich")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("Elective Affinities")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("The Wooden Madonna")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("Parents and Children")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("The Discipline of Memory")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("A Change of Program")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('i', [_vm._v("Music in the Cathedral")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/bio",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Biography of Madeleine L’Engle")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0